import { render } from "./RequestsTab.vue?vue&type=template&id=5f0b340b&scoped=true"
import script from "./RequestsTab.vue?vue&type=script&lang=js"
export * from "./RequestsTab.vue?vue&type=script&lang=js"

import "./RequestsTab.vue?vue&type=style&index=0&id=5f0b340b&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0b340b"]])

export default __exports__